import { useGetTimberClassQuery, useGetTimberClassPresentationQuery } from "../../../../timber/apis/TimberClass.api";
import { TimberClassNameDisplay } from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import { toString as toStringTimberClass, PrimaryTimberClass } from "../../../../timber/types/models/TimberClass";
import * as crudgen from "../../../../share";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import { Button, IconButton, Stack, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Add as AddIcon } from "@mui/icons-material";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import {ID} from "../../../../types/global.d";
import {useLocationFormState} from "./TimberClassAddForm";
import TimberClassAddFormProvider from "./TimberClassAddFormProvider";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {DescriptionAlert} from "../../../../share";
import { useFormContext } from 'react-hook-form';
import {useStateSession} from "../../../../hooks/useAuth";

const EMPTY_PAGINATION = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

const AddDialog = ({name}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDialog, setShowDialog] = React.useState<boolean>(false)
    const {setValue} = useFormContext()

    return (
        <>
            <IconButton aria-label={ t`Add Timber Class` } onClick={() => setShowDialog(true)} size="small">
                <AddIcon />
            </IconButton>
            <Dialog
                open={showDialog}
                fullScreen={fullScreen}
                onClose={() => setShowDialog(false)}>
                <DialogTitle><Trans>Add Timber Class</Trans></DialogTitle>
                <DialogContent>
                    <DescriptionAlert/>
                    <TimberClassAddFormProvider
                        successAction={
                            (data) => {
                                setValue(name, data.id)
                                setShowDialog(false)
                            }
                        }
                        cancelButton={<Button onClick={() => setShowDialog(false)}><Trans>Cancel</Trans></Button>}
                        initialFormState={useLocationFormState}
                        redirectPath="."
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

const TimberClassFormSelect = ({type, name, label, prefix, required, onValueChange, filter = {}} :
                                        {type: string, name: string, label: string, prefix: string, required: boolean, onValueChange?: (option: any) => void, filter: {
                                                name: string,
                                                }
                                        })  => {

    const session = useStateSession()
    const [, setInputTerm, inputTerm] = useSearchDebounce();

    const { data = EMPTY_PAGINATION,
        isLoading,
        isFetching,
    } = useGetTimberClassPresentationQuery({
      list: {
        page: 0,
        pageSize: 12,
      },
      filter: {
            name: inputTerm || '',
            nameOr: true,
            ...filter,
      },
    })

    if (type === 'select') {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetTimberClassQuery(PrimaryTimberClass.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringTimberClass }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><TimberClassNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/TimberClasses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    } else {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetTimberClassQuery(PrimaryTimberClass.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringTimberClass }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><TimberClassNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/TimberClasses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    }
}

export default TimberClassFormSelect